import Utils from '../../services/utils';

export const regimesValueLabelList = [
  { label: 'Régimen Común', value: 'O-11' }, // aplica retefuente y reteica
  { label: 'Régimen Simple', value: 'O-49' }, // aplica retefuente y reteica
  { label: 'Régimen Simplificado', value: 'O-47' }, // reteiva
  { label: 'Gran contribuyente', value: 'O-13' },
  { label: 'Autorretenedor', value: 'O-15' },
  { label: 'Agente de retención IVA', value: 'O-23' },
  { label: 'No aplica – Otros *', value: 'R-99-PN' }
];

export const regimesLabelsObject = Utils.valueLabelListToLabelsObject(regimesValueLabelList);
